// The layout stays in the browser until the backend has the user setting
// `reporting_chart_layout` (T20-142083).
export const CHART_LAYOUT_STORAGE_KEY = 'reportingChartLayout';
